import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const LeadContext = createContext(null);
const STORAGE_KEY = "bs_lead_draft";

const PERSISTED_KEYS = [
  "supplyRate", "monthlyKwh", "calcResults",
  "businessName", "contactName", "email", "phone", "message",
];

export function LeadProvider({ children }) {
  const [lead, setLead] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  });
  const [billFile, setBillFile] = useState(null);

  const update = useCallback((patch) => {
    setLead((l) => ({ ...l, ...patch }));
  }, []);

  useEffect(() => {
    try {
      const persist = {};
      PERSISTED_KEYS.forEach((k) => {
        if (lead[k] !== undefined) persist[k] = lead[k];
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(persist));
    } catch {
      /* storage unavailable */
    }
  }, [lead]);

  const value = useMemo(
    () => ({ lead, update, billFile, setBillFile }),
    [lead, update, billFile]
  );

  return <LeadContext.Provider value={value}>{children}</LeadContext.Provider>;
}

export const useLead = () => useContext(LeadContext);
